import { ApiUtil } from "../utils/ApiUtils";

export const logout = async () => {
    await ApiUtil.post('/main/logout2');
}